var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8516 15.4251V18.36",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1284 15.4251V18.36",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 14.0261H5.2V12.3193C5.2 12.2487 5.52 12.2016 6 12.2016H18C18.48 12.2016 18.8 12.2487 18.8 12.3193V14.0261Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1748 14.0261V18.36",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93967 14.0261V18.36",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3051 12.2016H9.67462V10.2242C9.67462 9.90963 9.79648 9.63998 9.93864 9.63998H14.0614C14.2035 9.63998 14.3254 9.90963 14.3254 10.2242V12.2016H14.3051Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3051 15.4251H9.67462V14.3452C9.67462 14.1733 9.79648 14.0261 9.93864 14.0261H14.0614C14.2035 14.0261 14.3254 14.1733 14.3254 14.3452V15.4251H14.3051Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.30ad8f3b1af3322ecb26f946091ce41f.svg";
export { ForwardRef as ReactComponent };